import templateUrl from './audit-log-entry-history-modal.component.html'

export const AuditLogHistoryEntryModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controllerAs: "vm",
    controller: class AuditLogEntryHistory {
        $onInit() {
            this.auditLogEntry = this.resolve.auditLogEntry;
            this.title = this.resolve.title;
        }
        onClose() {
            this.dismiss({ $value: 'close' });
        }
    }

};

export const AuditLogHistoryEntryModal = {
    component: "apexAuditLogHistoryEntryModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
};
